import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

// [AI_START::function id="ExportEmailNotice" purpose="One short line telling the dealer where the export link goes; the address is bold purple; the 7-day note shows only next to the full-archive button" links=["ContactsExportModal", "FullExportButton", "DataExportSettings"]]
const ExportEmailNotice: FC<{
  email?: string | null;
  showLinkLifetime?: boolean;
}> = ({ email, showLinkLifetime = false }) => {
  const { t } = useTranslation();
  return (
    <p className="dealer-export__notice">
      <Trans
        i18nKey={
          showLinkLifetime ? "export.link-notice-full" : "export.link-notice"
        }
        values={{ email: email || t("export.organization-email") }}
        components={{ email: <strong className="dealer-export__email" /> }}
      />
    </p>
  );
};
// [AI_END::ExportEmailNotice]

export default ExportEmailNotice;
